import { gql } from '@apollo/client';
import { ModifyOrganizationInput } from 'types/Organization';

const updateOrganization = (
    organizationUri: string,
    input: ModifyOrganizationInput,
) => {
    return {
        variables: {
            organizationUri,
            input,
        },
        mutation: gql`
            mutation UpdateOrg(
                $organizationUri: String
                $input: ModifyOrganizationInput
            ) {
                updateOrganization(
                    organizationUri: $organizationUri
                    input: $input
                ) {
                    organizationUri
                    label
                    created
                }
            }
        `,
    };
};

export default updateOrganization;
